import * as React from 'react'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Proposer from './Proposer'
import Member from './Member'
import MedicalQuestions from './MedicalQuestions'
import Nominee from './Nominee'
import { useTheme, Grid2 as Grid, Button } from '@mui/material'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Colors from '../../../utils/colors.json'
import ShareIcon from '@mui/icons-material/Share'
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload'

const styles = () => ({
  containerProposerDeclaration: {
    overflow: 'auto',
  },
  stepperContainer: {
    background: Colors.APP_BG,
  },
  btnShare: {
    textTransform: 'capitalize',
    fontSize: '12px',
    background: Colors.TEXT_COLOR_SECONDARY,
    borderRadius: '20px',
  },
  btnDownload: {
    textTransform: 'capitalize',
    fontSize: '12px',
    textDecoration: 'underline',
  },
})

const steps = ['Proposer', 'Member', 'Medical', 'Nominee']

export const ProposerDeclaration = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [activeStep, setActiveStep] = React.useState(0)

  // const handleNext = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1)
  // }

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1)
  // }

  // const handleReset = () => {
  //   setActiveStep(0)
  // }

  const RenderTab = ({ tab }: { tab: number }) => {
    switch (tab) {
      case 0:
        return (
          <Proposer activeStep={activeStep} setActiveStep={setActiveStep} />
        )
      case 1:
        return <Member activeStep={activeStep} setActiveStep={setActiveStep} />
      case 2:
        return (
          <MedicalQuestions
            activeStep={activeStep}
            setActiveStep={setActiveStep}
          />
        )
      case 3:
        return <Nominee activeStep={activeStep} setActiveStep={setActiveStep} />
      default:
        return null
    }
  }

  return (
    <Grid container direction='column' spacing={4}>
      <Grid
        container
        size={{ xs: 12 }}
        position={'sticky'}
        top={0}
        zIndex={1}
        className={classes?.stepperContainer}
        alignItems={'center'}
      >
        <Button
          variant='contained'
          endIcon={<ShareIcon />}
          className={classes?.btnShare}
        >
          Share PF
        </Button>
        <Button
          variant='text'
          endIcon={<SimCardDownloadIcon />}
          className={classes?.btnDownload}
        >
          Download
        </Button>
        <Grid flex={1}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {}
              const labelProps: {
                optional?: React.ReactNode
              } = {}
              return (
                <Step key={index} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              )
            })}
          </Stepper>
        </Grid>
        <Button
          variant='contained'
          endIcon={<ShareIcon />}
          className={classes?.btnShare}
        >
          Share Brochure
        </Button>
      </Grid>

      <Grid
        size={{ xs: 12 }}
        container
        pr={2}
        className={classes?.containerProposerDeclaration}
      >
        <RenderTab tab={activeStep} />
      </Grid>
    </Grid>
  )
}

export default ProposerDeclaration
